import { useQuery } from '@tanstack/react-query';

export function useArticles() {
    return useQuery({
        queryKey: ['articles'],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/articles/all';
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}